import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../utils/api';

const SYSTEM_IMAGES_QUERY_KEY = 'systemImages';

export const useSystemImages = () => {
  return useQuery({
    queryKey: [SYSTEM_IMAGES_QUERY_KEY],
    queryFn: () => apiClient.content.getSystemImages(),
    staleTime: 5 * 60 * 1000,
  });
};

export const useUpdateSystemImage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, imageFile }) => apiClient.content.updateSystemImage(id, imageFile),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SYSTEM_IMAGES_QUERY_KEY] });
    },
  });
};
